import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetStagesetWidgets as GetStagesetWidgetsQuery,
    GetStagesetWidgetsVariables,
    GetStagesetWidgets_stageset as Stageset,
} from 'nutshell-graphql-types';

import GET_STAGESET_WIDGETS from '../queries/get-stageset-widgets.graphql';

export const useGetStagesetWidgets = (
    id: string
): {
    stageset: Stageset | null | undefined;
    isFirstLoad: boolean;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetStagesetWidgetsQuery,
        GetStagesetWidgetsVariables
    >(GET_STAGESET_WIDGETS, {
        variables: {
            id,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        stageset: data && data.stageset,
        isFirstLoad: isFirstLoad(networkStatus),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
